import api from '../../api';

const path = `/search`;

const getCarListRequest = (params) =>
    api.get(`${path}/sell/car/get`, {
        params,
    });

const getBikeListRequest = (params) =>
    api.get(`${path}/sell/bike/get`, {
        params,
    });

const getCommercialListRequest = (params) =>
    api.get(`${path}/sell/commercial/get`, {
        params,
    });

export { getCarListRequest, getBikeListRequest, getCommercialListRequest };
